export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';
export const CALENDAR_URL =
  process.env.REACT_APP_CALENDAR_URL || 'http://localhost:3000';
export const HOME_PAGE = process.env.REACT_APP_HOME_PAGE || '/clientportal';
